import { NgModule } from '@angular/core'
import { FuseCardModule } from '@fuse/components/card'
import { FuseAlertModule } from '@fuse/components/alert'
import { SharedModule } from 'app/shared/shared.module'
import { DirectivesModule } from 'app/directives/directive.module'
import { GroupPagareComponent } from './group-pagare.component'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatButtonModule } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { CommonModule } from '@angular/common'
import { MatDialogModule } from '@angular/material/dialog'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { PagareModule } from '../pagare/pagare.module'
import { Route, RouterModule } from '@angular/router'

const exampleRoutes: Route[] = [
    {
        path: "",
        component: GroupPagareComponent,
    },
];
@NgModule({
	declarations: [GroupPagareComponent],
    imports: [
        RouterModule.forChild(exampleRoutes),
		MatIconModule,
		CommonModule,
		MatInputModule,
		MatButtonModule,
		MatCheckboxModule,
		SharedModule,
		FuseCardModule,
		FuseAlertModule,
		DirectivesModule,
		MatDialogModule,
		MatProgressSpinnerModule,
		PagareModule,
	]
})
export class GroupPagareModule { }
